import { getSerpBannerSlots } from './getSerpBannerSlots';
import type { SerpBanner, SerpBannerContext, SerpBannerId, SerpBannersGrid, SerpStaticBanner } from '../model/types';

export interface SerpBannersSetup {
  priority: readonly SerpBannerId[];
  staticBanners: readonly SerpStaticBanner[];
  banners: Record<SerpBannerId, SerpBanner>;
  grid: SerpBannersGrid;
}

function isSerpBannerEnabled(banner: SerpBanner, context: SerpBannerContext): boolean {
  return !banner.isEnabled || banner.isEnabled(context);
}

export function getEnabledSerpBanners(setup: SerpBannersSetup, context: SerpBannerContext): SerpBanner[] {
  return setup.priority.map((id) => setup.banners[id]).filter((banner) => isSerpBannerEnabled(banner, context));
}

function getEnabledSerpStaticBanners(setup: SerpBannersSetup, context: SerpBannerContext): SerpStaticBanner[] {
  return setup.staticBanners.filter(({ id }) => isSerpBannerEnabled(setup.banners[id], context));
}

export function getSerpBannerAt(
  setup: SerpBannersSetup,
  context: SerpBannerContext,
  cardPosition: number,
): SerpBanner | null {
  const staticBanners = getEnabledSerpStaticBanners(setup, context);
  const staticBanner = staticBanners.find((item) => item.cardPosition === cardPosition);

  if (staticBanner) {
    return setup.banners[staticBanner.id];
  }

  const grid = staticBanners.find((item) => item.dynamicGrid)?.dynamicGrid ?? setup.grid;
  const slot = getSerpBannerSlots(getEnabledSerpBanners(setup, context), grid, context.totalCards).find(
    (item) => item.cardPosition === cardPosition,
  );

  return slot ? setup.banners[slot.bannerId] : null;
}
